import React from 'react';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { media } from '../../src/styles/media';

import { Section, Media } from '../../src/components/Layout';
import { Container } from '../../src/components/Grid';
import { H3 } from '../../src/components/Title';

const MediaReverse = styled(Media)`
  flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};

  h2 {
    margin-top: 0 !important;
    font-size: ${props => props.smallTitle && '22px'};
  }

  div:first-child {
    > div {
      max-height: 350px;
    }
  }

  img {
    max-height: 350px;
  }

  ${media.tablet`
    flex-direction: row-reverse;
  `};
`;

const regex = /<p>(.*?)<\/p>/g;
const splitContent = content => {
  const matches = content.match(regex);
  if (matches && matches.length > 0) {
    return matches;
  }

  return content;
};

class Management extends React.PureComponent {
  render() {
    const { page, t } = this.props;
    const content = splitContent(page.detail.block_word_content);
    const [firstContent, secondContent, ...rest] = content;
    const restContent = rest.join('');
    return (
      <Section>
        <Container>
          <Fade up>
            <H3 icon="word" border={true}>
              {t('common:place.director')}
            </H3>
          </Fade>
          <MediaReverse
            title={page.detail.block_word_title}
            img={page.img_visual_top_mobile}
            imgDesktop={page.img_visual_top_desktop}
            smallTitle
          >
            <p dangerouslySetInnerHTML={{ __html: firstContent }} />
          </MediaReverse>
          <MediaReverse
            img={page.img_visual_bottom_mobile}
            imgDesktop={page.img_visual_bottom_desktop}
            smallTitle
            reverse
          >
            <p dangerouslySetInnerHTML={{ __html: restContent }} />
          </MediaReverse>
        </Container>
      </Section>
    );
  }
}

Management.propTypes = {
  page: PropTypes.object
};

export default translate()(Management);
